import { useSitePages } from "../pages/nav";
import { pageOf } from "../pages/registry";
import { NotFound } from "./NotFound";

/**
 * UNE PAGE DU SITE — pour l'instant, l'aveu qu'elle n'est pas encore construite.
 *
 * ⚠️ ET C'EST DÉLIBÉRÉ PLUTÔT QUE PROVISOIRE-ET-CACHÉ. Les pages du registre s'activent
 * dès maintenant dans le menu et sur l'accueil, parce que c'est ce qui était demandé :
 * régler le site. Mais leur contenu — programme, badge, album, classement — c'est autant
 * d'écrans à part entière, qui viennent un par un. Entre les deux, un menu qui mène à du
 * vide serait pire que pas de menu : le participant clique et ne comprend pas, et
 * l'organisateur croit son site en ligne.
 *
 * Alors la page le DIT, avec son propre nom en titre — celui que l'organisateur a
 * écrit — pour qu'on voie bien que le réglage a pris.
 *
 * Displayed strings are French: this is a French product.
 */
/**
 * ⚠️ THE KEY ARRIVES AS A PROP, NO LONGER FROM THE ADDRESS. The pages are STATIC routes
 * now (`/badge`, `/album`…): there is no `:page` segment left to read, and the router is
 * the one that knows which page it mounts — see `main.tsx`, which says why the dynamic
 * segment had to go.
 */
export function SitePage({ pageKey }: { pageKey: string }) {
  const page = pageOf(pageKey);
  const { name } = useSitePages();

  // A key matching no page in the registry is an unknown address, not an empty page.
  // The router should never produce one — the routes are generated from that same
  // registry — but the guard costs a line.
  if (!page) return <NotFound />;

  return (
    <section className="page">
      <div className="ttl">
        <h2>{name(page)}</h2>
        <p>{page.subtitle}</p>
      </div>

      <div className="alert">
        <span className="alert__d" aria-hidden="true">
          <i />
        </span>
        <span>
          <b>Cette page n'est pas encore construite</b>
          <small>
            Elle apparaît déjà où vous l'avez activée — dans le menu, sur
            l'accueil — et son contenu arrive prochainement.
          </small>
        </span>
      </div>
    </section>
  );
}
